import React, { useRef, forwardRef } from 'react';
import { useWindowSize } from 'hooks';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Parallax = forwardRef((props, ref) => {
  const { style, children, speed = 1.7, id = 'parallax' } = props;
  const trigger = useRef();
  const target = useRef();
  const timeline = useRef();
  const { windowWidth } = useWindowSize();

  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);

      const y = windowWidth * speed * 0.1;
      const setY = gsap.quickSetter(target.current, 'y', 'px');

      timeline.current = gsap.timeline({
        scrollTrigger: {
          id,
          trigger: trigger.current,
          scrub: true,
          start: 'clamp(top bottom)',
          end: 'clamp(bottom top)',
          onUpdate: (e) => {
            setY(e.progress * y);
          }
        }
      });

      return () => {
        timeline?.current?.kill();
      };
    },
    { dependencies: [id, speed, windowWidth] }
  );

  return (
    <div ref={trigger} className={props.className} style={style}>
      <div ref={ref}>
        <div ref={target}>{children}</div>
      </div>
    </div>
  );
});

export default Parallax;
